<template>
  <div class="content">
    <el-form
      :inline="true"
      :model="form"
      ref="cardform"
    >
      <el-form-item :label="$t('lang.Card number')"
                    :rules="{ required: true, message: $t('lang.Enter or read the card number'), trigger: 'blur' }"
                    prop="cardAccountNo">
        <el-input maxlength="50" v-model="form.cardAccountNo"
                  @keyup.native="form.cardAccountNo = form.cardAccountNo.replace(/[^\w\.\/]/ig,'')"
                  :placeholder="$t('lang.Enter or read the card number')" autofocus clearable/>
      </el-form-item>
      <el-form-item :label="$t('lang.Agent/Store')"
                    :rules="{ required: true, message: $t('lang.Please select an organization'), trigger: ['blur'] }">
        <query-unit-tree @change="handleChange"/>
      </el-form-item>
    </el-form>
    <h3 class="h3">{{ $t('lang.Choose battery') }}</h3>
    <el-table
      class="mb20"
      highlight-current-row
      ref="tableBattery"
      :data="tableBatteryData"
      style="width: 100%"
      @row-click="rowClickTop"
    >
      <el-table-column prop="commodityNo" :label="$t('lang.Product number')"></el-table-column>
      <el-table-column prop="name" :label="$t('lang.Product name')"></el-table-column>
      <el-table-column prop="ratedVoltageStandard" :label="$t('lang.Battery spec')">
        <template slot-scope="{row}" v-if="row.ratedVoltageStandard">
          {{ row.ratedVoltageStandard || 0 }}V
        </template>
      </el-table-column>
      <el-table-column prop="price" :label="$t('lang.Commodity price')">
        <template slot-scope="{row}" v-if="row.price">
          {{ row.price || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="deposit" :label="$t('lang.Deposit')">
        <template slot-scope="{row}">
          {{ row.deposit }}
        </template>
      </el-table-column>
      <!--      <el-table-column prop="timeLength" :label="$t('lang.Effective time')">
              <template slot-scope="{row}" v-if="row.timeLength">
                {{ row.timeLength || 0 }}{{ $t('lang.day') }}
              </template>
            </el-table-column>-->
    </el-table>
    <div class="choose-card-type-title">
      <h3 class="h3 mr20">{{ $t('lang.Choose a package') }}</h3>
      <el-radio-group v-model="cardType" @change="selectTypeChange">
        <el-radio-button label="1">{{ $t('lang.Measured card') }}</el-radio-button>
        <el-radio-button label="2">{{ $t('lang.Timer card') }}</el-radio-button>
      </el-radio-group>
    </div>
    <el-table
      @row-click="rowClick"
      class="mb20"
      highlight-current-row
      ref="table"
      :data="needShowCard"
      style="width: 100%"
    >
      <el-table-column prop="commodityNo" :label="$t('lang.Product number')"></el-table-column>
      <el-table-column prop="name" :label="$t('lang.Product name')"></el-table-column>
      <el-table-column prop="price" :label="$t('lang.Product types')">
        <template slot-scope="{row}">
          <div v-if="row.type == 15">{{ $t('lang.Measured card') }}</div>
          <div v-if="row.type == 4">{{ $t('lang.Timer card') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ratedVoltageStandard" :label="$t('lang.Product types')">
        <template slot-scope="{row}" v-if="row.ratedVoltageStandard">
          {{ row.ratedVoltageStandard || 0 }}V
        </template>
      </el-table-column>
      <el-table-column prop="price" :label="$t('lang.Commodity price')">
        <template slot-scope="{row}" v-if="row.price">
          {{ row.price || 0 }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Quantity')">
        <template slot-scope="{row}" v-if="row.flag">
          <el-input-number v-model="form.cardQuantity" @change="handleCount" :min="1"
                           :label="$t('lang.Quantity')"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="timeLength" :label="$t('lang.Effective time')">
        <template slot-scope="{row}" v-if="row.timeLength">
          {{ row.timeLength || 0 }}{{ $t('lang.day') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Available times')">
        <template slot-scope="{row}">
          {{ row.frequency || '--' }}
          <span v-if="row.frequency">{{ $t('lang.times') }}</span>
        </template>
      </el-table-column>
    </el-table>
    <h3 class="h3 mb20">{{ $t('lang.Payment details') }}</h3>
    <el-divider></el-divider>
    <div class="mb20">
      <!-- tableBatteryData[0]['deposit'] -->
      <span class="mr20 ml24">{{ $t('lang.Deposit') }}฿{{ deposit }}</span>
      <span class="mr20">{{ $t('lang.Rent') }}฿{{ rentCom }}</span>
      <span class="mr20">{{ $t('lang.Number of replacement cards') }}{{ form.cardQuantity }}</span>
      <span>{{ $t('lang.Total amount') }}฿{{ money }}</span>
    </div>
    <el-divider></el-divider>
    <el-form class="el-form-box" label-width="100px" ref="form" :model="form">
      <el-form-item :label="$t('lang.Card password')"
                    label-width="130px"
                    :rules="{ required: true, message: $t('lang.Enter Card password'), trigger: 'blur' }"
                    prop="cardPassWord">
        <el-input v-model="form.cardPassWord"
                  @keyup.native="form.cardPassWord = form.cardPassWord.replace(/[^\w\.\/]/ig,'')" type="password"
                  maxlength="6" clearable/>
      </el-form-item>
      <el-form-item :label="$t('lang.user name')" label-width="130px">
        <el-input maxlength="50" v-model="form.name" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.phone')" label-width="130px">
        <el-input v-model="form.contactInfo" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="cancelBtn">{{ $t('lang.Cancel') }}</el-button>
        <el-button @click="confirmBtn('form','cardform')" type="primary">{{ $t('lang.Confirm') }}</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="$t('lang.Card opening details')"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="content">
        <div class="detailBox">
          <p>{{ $t('lang.Battery') }}</p>
          <el-table
            :data="rowTop"
            style="width: 100%">
            <el-table-column prop="commodityNo" :label="$t('lang.Battery Number')"></el-table-column>
            <el-table-column prop="ratedVoltageStandard" :label="$t('lang.Battery spec')">
              <template slot-scope="{row}">
                {{ row.ratedVoltageStandard }}V
              </template>
            </el-table-column>
            <el-table-column prop="date" :label="$t('lang.Commodity price')">
              <template slot-scope="{row}">
                ฿{{ row.price }}
              </template>
            </el-table-column>
            <el-table-column prop="date" :label="$t('lang.Deposit')">
              <template slot-scope="{row}">
                ฿{{ row.deposit }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="detailBox">
          <p>{{ $t('lang.Set meal') }}</p>
          <el-table
            :data="rowBottom"
            style="width: 100%">
            <el-table-column prop="commodityNo" :label="$t('lang.Product number')"></el-table-column>
            <el-table-column prop="name" :label="$t('lang.Product name')"></el-table-column>
            <el-table-column prop="price" :label="$t('lang.Commodity price')">
              <template slot-scope="{row}">
                <div v-if="row.type == 15">{{ $t('lang.Measured card') }}</div>
                <div v-if="row.type == 4">{{ $t('lang.Timer card') }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="price" :label="$t('lang.Commodity price')">
              <template slot-scope="{row}">
                ฿{{ row.price }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.Quantity')">
              <template slot-scope="{row}">
                {{ form.cardQuantity }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.Effective Total Time')">
              <template slot-scope="{row}">
                {{ row.timeLength }}{{ $t('lang.day') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.Effective Total Time')">
              <template slot-scope="{row}">
                {{ row.frequency || '--' }}
                <span v-if="row.frequency">{{ $t('lang.times') }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="detailBox">
          <p>{{ $t('lang.Amount') }}</p>
          <el-table
            :data="moneyTableData"
            style="width: 100%">
            <el-table-column prop="date" :label="$t('lang.Deposit')">
              <template slot-scope="{row}">
                ฿{{ deposit }}
              </template>
            </el-table-column>
            <el-table-column prop="date" :label="$t('lang.Total Rent')">
              <template slot-scope="{row}">
                ฿{{ rentCom }}
              </template>
            </el-table-column>
            <el-table-column prop="date" :label="$t('lang.Total amount')">
              <template slot-scope="{row}">
                ฿{{ money }}
              </template>
            </el-table-column>
          </el-table>
        </div>


        <!-- <p class="contentMsgBox mb10">
            <span>电池型号</span>
            <span>{{ratedVoltageStandard}}V</span>
        </p>
        <p class="contentMsgBox mb10">
            <span>电池押金</span>
            <span>฿{{deposit}}</span>
        </p>
        <p class="contentMsgBox mb10">
            <span>换电卡数量</span>
            <span>{{form.cardQuantity}}</span>
        </p>
        <p class="contentMsgBox mb20">
            <span>换电卡金额</span>
            <span>฿{{price}}</span>
        </p>
        <p class="contentMsgBox ">
            <span>总金额</span>
            <span>฿{{money}}</span>
        </p> -->
      </div>

      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $t('lang.Cancel') }}</el-button>
                <el-button type="primary" @click="registerCard">{{ $t('lang.Confirm') }}</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import {registerCard, queryRegisterCardCommodity} from '@/api/openCard';
import queryUnitTree from '@/components/common/queryUnitTree';

export default {
  data() {
    return {
      moneyTableData: [{}],
      rowBottom: '',
      rowTop: '',
      registerCardFlag: true,
      dialogVisible: false,
      unitNoArr: [],
      form: {
        cardAccountNo: '',
        cardPassWord: '',
        name: '',
        contactInfo: '',
        batteryCommodityNo: '',//电池商品编号
        cardCommodityNo: '',//换电卡商品编号
        cardQuantity: ''//换电卡数量
      },
      tableBatteryData: [],
      tableData: [],
      newTableData: [],
      deposit: 0,
      //换电卡类型，1次卡类型，2时卡类型
      cardType: '1',
    }
  },
  mounted() {
    console.log(this.tableBatteryData, this.tableData, '111');
  },
  computed: {
    //需要展示的卡
    needShowCard() {
      // return this.newTableData
      return this.newTableData.filter((el) => {
        return (el.type == 15 && this.cardType == 1) || (el.type == 4 && this.cardType == 2)
      })
    },
    rentCom() {//租金
      if (this.rowBottom[0]) {
        return (this.rowBottom[0].price * this.form.cardQuantity).toFixed(2)
      }
      return 0;
    },
    money() {//总金额=押金+租金*数量
      return (+this.rentCom + +this.deposit).toFixed(2);
    },
    //   depositCom(){//押金
    //     return
    //   }
  },
  methods: {
    //   获取table数据
    async queryRegisterCardCommodity() {
      this.form.cardQuantity = 0;
      this.form.cardCommodityNo = '';
      this.form.batteryCommodityNo = '';
      this.price = 0;
      this.deposit = 0;
      this.rowBottom = [];
      this.rowTop = [];
      const params = {};
      if (this.unitNoArr && this.unitNoArr.length > 0) {
        params.unitNo = this.unitNoArr[this.unitNoArr.length - 1]
      } else {
        params.unitNo = null;
      }
      const res = await queryRegisterCardCommodity(params);
      console.log(res, '开卡list');
      this.tableData = [];
      this.tableBatteryData = [];
      this.newTableData = [];
      if (res.ldata.length === 0) {
        return;
      }
      //电池:6
      this.tableBatteryData = res.ldata.filter((el) => {
        return el.type == 6
      })
      //换电卡:4,换电卡，15,换电卡（限次数）
      this.tableData = res.ldata.filter((el) => {
        return el.type == 4 || el.type == 15
      })
    },
    // select组件
    handleChange(val) {
      console.log(val, 'val1');
      this.unitNoArr = val;
      this.queryRegisterCardCommodity();
    },
    //取消
    cancelBtn() {
      this.$router.push('/managePage/warningRuleMgmt');
    },
    //   联系方式下的确定按钮
    confirmBtn(formName, formName2) {
      console.log(this.rowTop, this.rowBottom, 'row111111');
      if (this.form.cardPassWord.length !== 6) {
        this.$message.warning(this.$t('lang.The password should be six digits'));
        return;
      }
      if (!this.form.batteryCommodityNo || !this.form.cardCommodityNo) {
        this.$message.warning(this.$t('lang.Please select package and battery'));
        return;
      }
      console.log(this.unitNoArr, 'this.unitNoArr');
      if (!this.unitNoArr || this.unitNoArr.length === 0) {
        this.$message.warning(this.$t('lang.Please select agent'));
        return;
      }
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return;
        }
      })
      this.$refs[formName2].validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.dialogVisible = true;
      })
    },
    // 选中上面
    rowClickTop(row) {
      this.rowTop = [row];
      this.rowBottom = [];
      console.log(row, 'rowClickTop');
      this.form.batteryCommodityNo = row.commodityNo;
      this.deposit = row.deposit;
      this.ratedVoltageStandard = row.ratedVoltageStandard;
      this.newTableData = [];
      this.form.cardCommodityNo = '';
      this.tableData.forEach((el, i) => {//选电池，展示对应套餐，tableData所有套餐，newTableData筛选后的套餐
        el.ratedVoltageStandard == this.ratedVoltageStandard ? this.newTableData.push(el) : '';
      })
      // if(this.newTableData.length === 0){//
      //     this.newTableData = this.tableData;
      // }
    },
    //选中的类型改变，是次卡还是时卡
    selectTypeChange() {
      this.rowBottom = [];
      this.form.cardCommodityNo = '';
    },
    // 点table某行
    rowClick(row, col, e) {
      this.rowBottom = [row];
      console.log(row, 'rowClick');
      this.newTableData.forEach((el, i) => {//控制数量input展示
        el.flag = false;
      })
      row.flag = true;
      this.form.cardCommodityNo = row.commodityNo;
      this.price = row.price;
      console.log(row, 'row');
    },
    // 计数器
    // handleCount(value) {
    //     console.log(value);
    // },
    // 确定（付款）
    async registerCard() {
      console.log(1);
      if (!this.registerCardFlag) {
        return;
      }
      console.log(1);

      this.registerCardFlag = false;
      console.log(1);

      const params = {...this.form};
      params.cardPassWord = this.$md5(params.cardPassWord);
      console.log(1);

      const res = await registerCard(params);
      console.log(res, '开卡返回');
      if (res.result === 1) {
        this.$message.success(this.$t('lang.Successful'));
        setTimeout(() => {
          this.$router.push('/managePage/warningRuleMgmt');
        }, 1000);
      }
      this.dialogVisible = false;
      this.registerCardFlag = true;
    }
  },
  components: {
    queryUnitTree,
  }
}
</script>

<style scoped>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-form-box {
  width: 300px;
}

.contentMsgBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detailBox {
  margin-bottom: 20px;
  margin-left: 20px;
}

.choose-card-type-title {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/warningMgmt/warningRecord.vue